<template>
    <div id="error">
        <div class="content">
            <img :class="isMobile ? 'mob' : ''" :src="errorIMG" />
            <div class="text">
                <h1 v-if="msg != ''">{{ msg }}</h1>
                <h1 v-if="msg == ''">对不起！我们的服务出现了问题，请稍后重试。</h1>
            </div>
            <div class="buttonBox" v-if="!isMobile">
                <el-button type="primary" @click="reload">再试一次</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import error from '@/assets/img/error.svg'

export default {
    name: 'error_page',
    props: {
        msg:{
            type: String,
            default: ''
        }
    },
    components:{
    },
    data() {
        return {
            errorIMG: error,
            isMobile: false
        }
    },
    methods: {
        reload(){
            window.location.reload();
        },
        isMob(){
            if(this.$root.isMob()){
                this.isMobile = true;
            }
        },
    },
    created(){
        this.isMob();
    }
}
</script>

<style lang="scss" scoped src="@/assets/css/error.scss"></style>